import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuRadioGroupProps extends PartProps<BaseContextMenu.RadioGroup.Props> {
  className?: string
}

function ContextMenuRadioGroup({ className, children, ...props }: ContextMenuRadioGroupProps) {
  return (
    <BaseContextMenu.RadioGroup className={twMerge(className)} {...props}>
      {children}
    </BaseContextMenu.RadioGroup>
  )
}

export { ContextMenuRadioGroup }
